import { useBrandingContext, useCustomLocale } from '@group-link-one/gl-components';
import type { ModalLogoutCustomLocale } from '../types/translations';
import type { IBranding } from '@/Branding';

interface UseModalLogoutTranslationReturn {
  t: ModalLogoutCustomLocale;
}

export const useModalLogoutTranslation = (): UseModalLogoutTranslationReturn => {
  const { brandingData } = useBrandingContext() as { brandingData: IBranding };
  const { customLocale } = useCustomLocale(brandingData.ModalLogout.locale);

  return {
    t: customLocale as ModalLogoutCustomLocale,
  };
};
